import Model from 'flarum/common/Model';
export default class GIF extends Model {
  gifID = Model.attribute('gifID');
}
flarum.reg.add('therealsujitk-gifs', 'forum/models/GIF', GIF);